const prepareOrderData = (data) => {
  const utcDate = new Date()
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ');

  return {
    order_marketplace_name: data?.marketplace,
    order_marketplace_account: data?.account,
    order_reference_no: data?.referenceNo,
    order_status: 'New',
    order_assembly_type: data?.orderAssemblyType?.value || 'Assembly',
    order_assembly_style: data?.order_assembly_style,
    order_assembly_urgency: data?.urgencyType,
    order_marketplace_sold_date: data?.marketplace === 'ebay' ? utcDate : (data?.soldDate
      || utcDate),
    order_listings_total_price: parseFloat(data?.totalPriceOriginal),
    order_handle_by_time: '',
    order_guaranteed_shipping_date: '',
    order_notes: data?.orderNotes,
    order_listings_title: data?.title,
    order_item_mpn: data?.mpn?.toLowerCase(),
    order_listing_car_make: data?.make,
    order_listing_car_model: data?.model,
    order_listing_car_year_range: data?.yearRange,
    order_car_lift_position: data?.liftPosition,
    order_item_shipping_weight: parseFloat(data?.weight),
    order_item_shipping_width: parseFloat(data?.width),
    order_item_shipping_height: parseFloat(data?.height),
    order_item_shipping_length: parseFloat(data?.length),
    order_checkout_message: data?.checkoutMessage,
    order_notes_to_client: data?.noteToClient,
    order_shipping_first_name: data?.firstName,
    order_shipping_last_name: data?.lastName,
    order_shipping_address: data?.address,
    order_shipping_address_line2: data?.address2,
    order_shipping_country: data?.country,
    order_shipping_state: data?.state,
    order_shipping_zip: data?.zip,
    order_shipping_city: data?.city,
    order_shipping_phone: data?.phone,
    order_shipped_date: '',
    order_marketplace_number: data?.marketplaceNumber || new Date().getTime(),
    order_label_file: data?.order_label_file,
    order_label_file2: data?.order_label_file2,
    order_assembly_invoice: data?.order_assembly_invoice,
  };
};

export default prepareOrderData;
